export const COMPONENT_TYPE = {
  AUTOCOMPLETE: 'autocomplete',
  AUTOCOMPLETE_BY_TYPE: 'autocompleteByType',
  CHECKBOX: 'checkbox',
  CUSTOM_FILTER: 'custom-filter',
  DATE: 'date',
  PREDEFINED: 'predefined',
  RADIO: 'radio'
};
